import React from 'react';
import PropTypes from 'prop-types';

import BonusListSkeleton from 'components/ClientProfile/Bonuses/BonusListSkeleton';
import BonusList from 'components/ClientProfile/Bonuses/DepositBonuses/BonusList';
import SeoPageText from 'components/SeoPage/SeoPageText';

const CombinedBonusesView = ({
  activateBonus,
  activateFreespin,
  availableTemplates,
  cancelFreespin,
  clientBonuses,
  deactivateBonus,
  freespins,
  loading,
  wallet,
}) => {
  if (loading) {
    return <BonusListSkeleton />;
  }

  return (
    <>
      <BonusList
        activateBonus={activateBonus}
        activateFreespin={activateFreespin}
        availableTemplates={availableTemplates}
        cancelFreespin={cancelFreespin}
        clientBonuses={clientBonuses}
        deactivateBonus={deactivateBonus}
        freespins={freespins}
        wallet={wallet}
      />
      <SeoPageText />
    </>
  );
};

CombinedBonusesView.propTypes = {
  activateBonus: PropTypes.func,
  activateFreespin: PropTypes.func,
  availableTemplates: PropTypes.array.isRequired,
  cancelFreespin: PropTypes.func,
  clientBonuses: PropTypes.array.isRequired,
  deactivateBonus: PropTypes.func,
  freespins: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  wallet: PropTypes.object,
};

export default CombinedBonusesView;
